import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from '@zauberware/react-i18n/web'

const Text = ({ value }) => {
  const { t } = useTranslation('dataManagement')

  if (typeof value === 'boolean') {
    return <span className="ant-form-text">{value ? t('yes') : t('no')}</span>
  }
  if (!value) return null
  if (typeof value !== 'string') {
    const returnValue = []
    value.map(val => {
      if (typeof val === 'string') returnValue.push(val)
      if (typeof val === 'object') returnValue.push(val.name)
      return true
    })
    return <span className="ant-form-text">{returnValue.join(',')}</span>
  }

  return <span className="ant-form-text">{value}</span>
}
Text.propTypes = {
  value: PropTypes.any
}
Text.defaultProps = {
  value: ''
}

export default Text
